import _ from 'lodash'
import { connect } from 'react-redux'
import Sync from '../../components/Sync'
import {
    actionServersSetServerStatus,
    actionAdsUpdateTimestamp,
    actionNewsUpdateHash,
    actionTwitchUpdateStatus,
    actionVersionUpdate,
    actionBackgroundUpdate,
    actionSyncUpdateHash,
} from '../../actions'
import { actions as toasterActions } from '../../features/Toaster'

function mapStateToProps({ toasterReducer, servers, sync }) {
    return {
        hash: sync.hash,
        newestMotdTimeStamp: toasterReducer.toasts.newestMessage.timeStamp,
        // TODO: FIX
        serverList: _.mapValues(servers.list, () => true),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setServerStatus: (name, status, count) => {
            dispatch(actionServersSetServerStatus({ name, status, count }))
        },
        addMotd: (data) => {
            dispatch(toasterActions.addMessage(data))
        },
        updateNewsHash: (newsHash) => {
            dispatch(actionNewsUpdateHash(newsHash))
        },
        updateAdsTimeStamp: (adsTimeStamp) => {
            dispatch(actionAdsUpdateTimestamp(adsTimeStamp))
        },
        updateTwitchStatus: (twitchStatus) => {
            dispatch(actionTwitchUpdateStatus(twitchStatus))
        },
        updateVersions: (versions) => {
            dispatch(actionVersionUpdate(versions))
        },
        updateBackground: (background) => {
            dispatch(actionBackgroundUpdate(background))
        },
        updateHash: (hash) => {
            dispatch(actionSyncUpdateHash(hash))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Sync)



// WEBPACK FOOTER //
// ./src/containers/Sync/sync.js